type ThreatLevel = 'none' | 'low' | 'medium' | 'high' | 'critical';

const dotColors: Record<ThreatLevel, { bg: string; border: string; glow?: boolean }> = {
  none: { bg: 'bg-gray-500', border: 'border-gray-400' },
  low: { bg: 'bg-cyan-400', border: 'border-cyan-300' },
  medium: { bg: 'bg-amber-400', border: 'border-amber-300' },
  high: { bg: 'bg-orange-500', border: 'border-orange-400' },
  critical: { bg: 'bg-red-500', border: 'border-red-400', glow: true },
};

export function ThreatBadge({ level }: { level: ThreatLevel }) {
  const colors = dotColors[level];
  
  return (
    <div className="relative inline-flex items-center justify-center w-3 h-3">
      <div className={`absolute inset-0 rounded-full ${colors.bg} opacity-20 ${colors.glow ? 'animate-ping' : ''}`} />
      <div className={`relative w-2 h-2 rounded-full ${colors.bg} border ${colors.border} ${colors.glow ? 'shadow-[0_0_8px_rgba(239,68,68,0.6)]' : ''}`} />
    </div>
  );
}
